import axios from "axios";
import Message from "ant-design-vue/lib/message"; // 加载 JS
// import "ant-design-vue/lib/message/style/css"; // 加载 CSS
import qs from "qs";

const newAxios = axios.create({
  withCredentials: true,
  timeout: 45000,
});

const request = ( url, method, params, isFormRequest, blob, msg ) => {
  return new Promise((resolve, reject) => {
    const defaultOptions = {
      method: "post",
      withCredentials: true,
    };
    const newOptions = {
      ...defaultOptions,
      url,
      method,
      blob,
    };
    const token = localStorage.getItem("token");
    // 是否form请求
    if (isFormRequest) {
      newOptions.headers = {
        "content-Type": "application/x-www-form-urlencoded",
        gagauthtoken: token,
      };
    } else {
      newOptions.headers = {
        "content-Type": "application/json;charset=UTF-8",
        gagauthtoken: token,
      };
    }

    if (newOptions.method === "post") {
      if (isFormRequest) {
        newOptions.data = qs.stringify(params);
      } else {
        newOptions.data = params;
      }
    } else if (newOptions.method === "get") {
      newOptions.params = params;
    }

    if (newOptions.blob === "blob") {
      newOptions.responseType = "blob";
    }

    newAxios(newOptions)
      .then((res) => {
        if (newOptions.blob === "blob") {
          const fileNames = res.headers["content-disposition"];
          const fileName = fileNames
            ? fileNames.split(";")[1].split("filename=")[1]
            : "";
          const content = res.data;
          const blob = new Blob([content]);
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const a = document.createElement("a"); // 创建一个a标签
            let url = window.URL.createObjectURL(blob);
            a.download = decodeURI(fileName); // 指定文件名称
            a.style.display = "none"; // 页面隐藏
            a.href = url; // href用于下载地址
            document.body.appendChild(a); // 插到页面上
            a.click(); // 通过点击触发
            // window.URL.revokeObjectURL(a.href); // 释放URL 对象
            document.body.removeChild(a); // 删掉a标签
          } else {
            // IE10 + 下载
            navigator.msSaveBlob(blob, decodeURI(fileName));
          }
        }
        const backData = res.data; // 接口返回的数据
        resolve(backData);

        if (backData.status === "F" && msg != "msg") {
          console.log("backData.status", backData.status);
          // 请求失败时
          Message.destroy();
          Message.error(backData.msg || "服务异常");
        } else if (backData.status === "T") {
          window.clearVuexAlong();
          localStorage.removeItem("token");
          window.location.href = "/login";
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default request;
